import "@hotwired/turbo-rails"
import "./controllers"

import { Turbo } from "@hotwired/turbo-rails"

Turbo.StreamActions.close_drawer = function () {
  const el = document.getElementById(this.getAttribute("target"))
  if (!el) return

  if (el.dataset.controller?.includes("modal")) {
    el.dispatchEvent(new CustomEvent("modal:close", { bubbles: false }))
  } else {
    el.dispatchEvent(new CustomEvent("drawer:close", { bubbles: false }))
  }
}

Turbo.StreamActions.clear_turbo_cache = function () {
  Turbo.cache.clear()
  Turbo.cache.exemptPageFromPreview()
}

Turbo.StreamActions.scroll_to_category = function () {
  const targetId = window.matchMedia("(min-width: 1024px)").matches
    ? this.getAttribute("desktop-target")
    : this.getAttribute("mobile-target")
  const category = document.getElementById(targetId)

  requestAnimationFrame(() => {
    category?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" })
  })
}
